import styled from 'styled-components';

export const Container = styled.div<{ disabled?: boolean }>`
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	display: flex;
	align-items: center;
	gap: 8px;
`;
